import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useRouter } from 'next/router';
import { BreadcrumbsPropType } from 'propTypes/common';

import SizeDependedBlock from 'components/SizeDependedBlock';
import Microdata from 'components/Microdata';

import Item from './components/Item';

import styles from './styles.module.scss';

const removeLeadingSlahes = (string) =>
	string ? string.replace(/^\/+/, '') : string;

const getPath = (currentPath, path, locale, rootRubricPath) => {
	if (!path || removeLeadingSlahes(currentPath) === removeLeadingSlahes(path)) {
		return null;
	}
	if (locale && rootRubricPath) {
		const rootRubrics = rootRubricPath.split('/');
		const rootRubricsAmount = rootRubrics.length;

		const pathRubricsDiff = path.split('/');
		const baseRubrics = pathRubricsDiff.slice(0, rootRubricsAmount);
		const restRubrics = pathRubricsDiff.slice(rootRubricsAmount);

		return [
			...baseRubrics,
			...(!_.isEmpty(restRubrics) ? [locale, ...restRubrics] : [])
		].join('/');
	}

	return path;
};

const exceptionNames = ['atlas'];

const Breadcrumbs = ({
	items,
	currentPath,
	rootRubricPath,
	gutter,
	microdata,
	showAllItems = false,
	currentEntityTitle
}) => {
	const { query } = useRouter();

	const prepareItems = () => {
		const exceptionItem = items.find((item) =>
			exceptionNames.includes(item.name)
		);
		if (exceptionItem) {
			return [exceptionItem];
		}
		const preparedItems = items.map(({ path, ...item }) => ({
			...item,
			path: getPath(currentPath, path, query?.locale, rootRubricPath)
		}));
		if (currentEntityTitle) {
			preparedItems.push({ title: currentEntityTitle });
		}
		return preparedItems;
	};

	const preparedItems = prepareItems();

	const mobileItem = _([...preparedItems].reverse()).find(({ path }) => !!path);
	const breadcrumbsCx = cx(
		styles.Breadcrumbs,
		styles[`Breadcrumbs_gutter_${gutter}`]
	);

	const renderBreadcrumbs = () =>
		_(preparedItems).map((item) => (
			<Item
				key={item?.title}
				title={item?.title}
				path={item?.path}
				mode="desktop"
			/>
		));
	return (
		<div className={breadcrumbsCx} data-cy="breadcrumbs">
			{microdata && <Microdata>{microdata}</Microdata>}
			{showAllItems ? (
				renderBreadcrumbs()
			) : (
				<SizeDependedBlock>
					<Item
						title={mobileItem?.title}
						path={mobileItem?.path}
						mode="mobile"
					/>
					{renderBreadcrumbs()}
				</SizeDependedBlock>
			)}
		</div>
	);
};

Breadcrumbs.propTypes = {
	items: BreadcrumbsPropType,
	currentPath: PropTypes.string,
	gutter: PropTypes.oneOf(['horizontalMobile']),
	microdata: PropTypes.node,
	showAllItems: PropTypes.bool,
	currentEntityTitle: PropTypes.string,
	rootRubricPath: PropTypes.string
};

Breadcrumbs.defaultProps = {
	items: []
};

export default Breadcrumbs;
